import { render } from "./KindColdEmails.vue?vue&type=template&id=a7b08276&lang=true"
import script from "./KindColdEmails.vue?vue&type=script&lang=js"
export * from "./KindColdEmails.vue?vue&type=script&lang=js"
script.render = render

export default script